import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, Typography, Pagination, PaginationItem, Input, Button, TextField } from '@mui/material';
import { Catalog, CatalogItem } from './components/catalog.component';
import { api } from '../../config/apiCaller.config';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RedemptionModal from './components/redemtpion.component';

const CatalogPage: React.FC = () => {
    const matches600 = useMediaQuery('(min-width:600px)');
    const [catalogItems, setCatalogItems] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(matches600 ? 8 : 4);
    const [totalPages, setTotalPages] = useState(0);
    const [text, setText] = useState<string | undefined>();
    const [minPoints, setMinPoints] = useState<number | undefined>();
    const [maxPoints, setMaxPoints] = useState<number | undefined>();
    const [selectedReward, setSelectedReward] = useState<CatalogItem | undefined>();

    const [textInput, setTextInput] = useState<string>();
    const [minPointsInput, setMinPointsInput] = useState<string>();
    const [maxPointsInput, setMaxPointsInput] = useState<string>();

    useEffect(() => {
        void loadItems();
    }, [page, limit, text, minPoints, maxPoints]);
    
    const loadItems = async () => {
        const response = await api.get(`/rewards?page=${page}&limit=${limit}${
            text ? `&text=${text}` : ''}${
                minPoints ? `&minPoints=${minPoints}` : ''}${
                    maxPoints ? `&maxPoints=${maxPoints}` : ''}`);
        if (response.status === 200) {
            setCatalogItems(response.data.data);
            setTotalPages(response.data.totalPages)
        }
    }

    const applyFilters = async () => {
        setPage(1);
        setText(textInput ?? undefined);
        setMinPoints(Number(minPointsInput) ?? undefined);
        setMaxPoints(Number(maxPointsInput ?? undefined));
    }

    const clearFilters = async () => {
        setPage(1);
        setTextInput("");
        setMinPointsInput(""); 
        setMaxPointsInput("");
        setText(undefined);
        setMinPoints(undefined);
        setMaxPoints(undefined);
    }

    return (
        <Box height="100vh" bgcolor="#FFFFFF">
            <Typography variant='h4' color='textPrimary'>Catálogo</Typography>
            <Typography variant="subtitle1" color="textSecondary">Aqui você pode ver os prêmios disponíveis para serem resgatados</Typography>

            <Box display={'flex'} justifyContent={'center'} p={2}>
                <form onSubmit={(e) => {e.preventDefault(); applyFilters()}} style={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                    <TextField variant="outlined" type="text" value={textInput} onChange={(e) => setTextInput(e.target.value)} placeholder='Filtrar por nome ou descrição' />
                    <TextField variant="outlined" type="number" value={minPointsInput} onChange={(e) => setMinPointsInput(e.target.value)} placeholder="Pontos mínimos" />
                    <TextField variant="outlined" type="number" value={maxPointsInput} onChange={(e) => setMaxPointsInput(e.target.value)} placeholder="Pontos máximos" />
                    <Box>
                        <Button type='button' variant='contained' style={{backgroundColor: '#D89274'}} onClick={clearFilters}>Limpar filtros</Button>
                        <Button type='submit' variant='contained' style={{backgroundColor: '#D89274', marginLeft: '3px'}}>Filtrar</Button>
                    </Box>
                </form>
            </Box>

            <RedemptionModal selectedReward={selectedReward} setSelectedReward={setSelectedReward}/>

            <Catalog items={catalogItems} setSelectedReward={setSelectedReward} />

            <Box display={'flex'} justifyContent={'center'} p={4}>
                <Pagination
                    count={totalPages}
                    page={page}
                    renderItem={(item) => (
                        <PaginationItem
                            slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                            {...item}
                            onClick={() => {setPage(item.page ?? 1)}}
                        />
                    )}
                />
            </Box>
        </Box>
    );
}

export { CatalogPage };
